import { z } from 'zod';
import { date } from '../atomic/date';

export const contractSchema = z.object({
  expireDate: date,
  signDate: date,
});
